import type { TabletColumns } from '@/components/WellLoggingOperations/types';
import type { ColumnsTooltipProps } from '@/components/WellLoggingOperations/types/columnsTooltipProps';
import { createModel } from '@rematch/core';
import type { RootModel } from '@/components/WellLoggingOperations/types';

const defaultColumnsTooltipProps: ColumnsTooltipProps = {
    wellServices: [],
    allGeoObjects: [],
    geoObjects: [
        'boredStratumAbsBottom',
        'boredStratumAbsRoof',
        'boredStratumBottom',
        'boredStratumRoof',
        'boredStratumThin',
        'boredStratumAbsThin',
        'boredStratumTitle',
        'boredStratumGnk',
        'boredStratumWnk',
        'boredStratumGvk',
        'params',
    ],
    lithology: [
        'stratumCount',
        'stratumTitle',
        'boredSeamAbsBottom',
        'boredSeamAbsRoof',
        'boredSeamBottom',
        'boredSeamRoof',
        'boredSeamThin',
        'boredSeamAbsThin',
        'lithology',
        'saturantTitle',
        'params',
    ],
    thicknessInterlayer: [
        'boredSeamAbsBottom',
        'boredSeamAbsRoof',
        'boredSeamBottom',
        'boredSeamRoof',
        'boredSeamThin',
        'boredSeamAbsThin',
        'saturantTitle',
        'params',
    ],
    stratigraphy: [],
    paramsHistogram: [],
    cementBondLogging: [],
    cementometry: [],
    innk: [],
    tech: [],
    tech_columns: [],
    tech_bridges: [],
    tech_cement: [],
    carrotage: [],
    core: [],
    testing: [],
    flowmetry: [],
    fluidTest: [],
    sample: [],
    stratigraphy_system: [],
    stratigraphy_overhorizon: [],
    stratigraphy_horizon: [],
    stratigraphy_department: [],
    stratigraphy_tier: [],
    tracers: [],
    coreParamsHistogram: [],
};

const columnsTooltipProps = createModel<RootModel>()({
    name: 'columnsTooltipProps',
    state: defaultColumnsTooltipProps as ColumnsTooltipProps,
    reducers: {
        toggleTooltipSetting: (state, payload: { columnKey: TabletColumns; propKeys: string[] }) => {
            const columnProps = state[payload.columnKey];
            let newProps: string[];
            if (payload.propKeys.every(pKey => columnProps.includes(pKey))) {
                newProps = columnProps.filter(key => !payload.propKeys.includes(key));
            } else {
                newProps = [...columnProps, ...payload.propKeys];
            }
            return {
                ...state,
                [payload.columnKey]: newProps,
            };
        },
        applyTooltipSettings: (state, payload: ColumnsTooltipProps) => {
            return payload;
        },
    },
});

export { columnsTooltipProps, defaultColumnsTooltipProps };
